import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "m25.6 16.9-3.3 3.3 1.4 1.4 5-5 .7-.7-.7-.7-5-5-1.4 1.5 3.2 3.2H3v2h22.6Z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
